import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { userOptionsStore } from '~/shared/api'
import { en, ru, fr } from './translation'

export const DEFAULT_LOCALE = 'ru'

export const initI18n = async () => {
  const userLocale = userOptionsStore.locale || DEFAULT_LOCALE

  i18next.use(initReactI18next).init({
    lng: userLocale,
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      fr: { translation: fr },
    },
    interpolation: {
      escapeValue: false,
    },
  })
}
